var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "de-container",
    [
      _vm.chart.type !== "table-normal" && _vm.chart.type !== "table-info"
        ? _c(
            "de-main-container",
            { staticClass: "full-div", style: _vm.customStyle },
            [
              _c(
                "div",
                { staticClass: "canvas-class", style: _vm.commonStyle },
                [
                  _vm.chart.isPlugin
                    ? _c("plugin-com", {
                        staticClass: "chart-class",
                        attrs: {
                          "component-name": _vm.chart.type + "-view",
                          obj: { chart: _vm.mapChart || _vm.chart },
                          chart: _vm.mapChart || _vm.chart,
                          "theme-style": _vm.element.commonBackground,
                          "canvas-style-data": _vm.canvasStyleData,
                        },
                      })
                    : !_vm.chart.type.includes("text") &&
                      _vm.chart.type !== "label" &&
                      !_vm.chart.type.includes("table") &&
                      _vm.renderComponent() === "echarts"
                    ? _c("chart-component", {
                        staticClass: "chart-class",
                        attrs: {
                          "theme-style": _vm.element.commonBackground,
                          chart: _vm.mapChart || _vm.chart,
                        },
                      })
                    : !_vm.chart.type.includes("text") &&
                      _vm.chart.type !== "label" &&
                      !_vm.chart.type.includes("table") &&
                      _vm.renderComponent() === "antv"
                    ? _c("chart-component-g2", {
                        staticClass: "chart-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm.chart.type === "table-pivot" &&
                      _vm.renderComponent() === "antv"
                    ? _c("chart-component-s2", {
                        staticClass: "chart-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm.chart.type.includes("text")
                    ? _c("label-normal", {
                        staticClass: "table-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm.chart.type === "label"
                    ? _c("label-normal-text", {
                        staticClass: "table-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _c(
            "de-main-container",
            [
              _c("table-normal", {
                staticClass: "table-class",
                attrs: { chart: _vm.chartTable, "show-summary": false },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }